import React from 'react';
import { Thead, Tr, Th, HStack, Box } from '@chakra-ui/react';
import { isNil, repeat } from 'ramda';
import ColumnSorter from '../ColumnSorter/ColumnSorter';
const SortableTableHead = ({ headers, onSort, currentSortOptions, leftPadding, }) => {
    const leftPaddingCells = !isNil(leftPadding) && leftPadding > 0
        ? repeat(0, leftPadding).map((offset) => React.createElement(Th, { key: offset }))
        : null;
    return (React.createElement(Thead, { "data-testid": "sortable_table_head" },
        React.createElement(Tr, null,
            leftPaddingCells,
            headers.map((header) => (React.createElement(Th, { cursor: header.sortField ? 'pointer' : 'default', key: header.title },
                React.createElement(HStack, null,
                    React.createElement(Box, { "data-testid": "sortable_table_head__title" }, header.title),
                    header.sortField && (React.createElement(ColumnSorter, { currentSortOptions: currentSortOptions, sortField: header.sortField, onSort: onSort })))))))));
};
export default SortableTableHead;
